import React from "react";
import portfolio from "../../assets/images/svg/portfolio.svg";
import { portFolioNoDataSubAssetClassMsg } from "../../utils/constants";

const Noportfolio = ({
  noDataMsg = portFolioNoDataSubAssetClassMsg,
  isTextOnly = false,
  msgClass = "",
}) => {
  return (
    <div className="no_finanacial_asset_derivative allocationTableOnly">
      {!isTextOnly && <img src={portfolio} alt="No Financial Assets" />}
      <p className={msgClass}>{noDataMsg}</p>
    </div>
  );
};

export default Noportfolio;
